<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-lg-12">
				<div class="d-flex flex-wrap flex-wrap align-items-center justify-content-between">
					<div>
						<h4 class="mb-3">{{ title }}</h4>
						<p class="mb-0">{{ desc1 }}<br> {{ desc2 }}<br>{{ desc3 }}</p>
					</div>
					<div class="d-flex flex-column">
						<b-button variant="primary pl-5 pr-5" class="mt-2 mr-1" @click="syncRealData">실제 데이터 동기화</b-button>
						<b-button variant="success pl-5 pr-5" class="mt-2 mr-1" @click="downloadExcel">엑셀 다운로드</b-button>
						<b-button variant="info pl-5 pr-5" class="mt-2 mr-1" v-b-modal.excelupload>엑셀 업로드</b-button>
					</div>
				</div>
			</div>
			<div class="col-lg-12">
				<img v-if="showspinner" style="max-width:100%;" :src="require('../../../assets/images/small/spinner.gif')">
				<div v-if="showspinner1" class="d-flex justify-content-center">
					<div><img style="max-width:10%;" :src="require('../../../assets/images/small/loading.gif')">{{ loadingtext }}</div>
				</div>
			</div>
		</div>

		<div class="row mt-3">
			<div class="col-lg-12" v-if="showlist">
				<div class="row d-flex justify-content-between">
					<div>
						<b-button variant="outline-primary" class="ml-3 mb-1 mr-2" @click="showAllProducts">
							전체 상품<b-badge variant="primary" class="ml-2">{{ totalProducts }}</b-badge>
						</b-button>
						<b-button variant="outline-success" class="mb-1 mr-2" @click="showProfitableProducts">
							수익 상품<b-badge variant="success" class="ml-2">{{ profitableProducts }}</b-badge>
						</b-button>
						<b-button variant="outline-danger" class="mb-1 mr-2" @click="showLossProducts">
							손실 상품<b-badge variant="danger" class="ml-2">{{ lossProducts }}</b-badge>
						</b-button>
					</div>
					<div>
						<button type="button" class="btn btn-info mr-2" @click="refreshData">새로고침</button>
						<button type="button" class="btn btn-success mr-2" @click="calculateProfit">수익 재계산</button>
					</div>
				</div>
			</div>

			<div class="col-lg-12" v-if="showlist">
				<CDataTable
					storage-key="BookkeepingManagement" :headers="headers" :items="filteredList.length > 0 ? filteredList : bookkeepingList" v-model="tableSelectedItem" :show-select="true"
					:fixedColumns="'상품명'" itemKey="vendorItemId" style="margin-bottom: 10px">

					<template v-slot:상품명="{ item }">
						<div @click="openProductDetail(item)" style="cursor: pointer;">{{ item.productName }}</div>
					</template>

					<template v-slot:옵션명="{ item }">
						<div @click="openProductDetail(item)" style="cursor: pointer;">{{ item.optionName }}</div>
					</template>

					<template v-slot:옵션ID="{ item }">
						<div @click="openProductDetail(item)" style="cursor: pointer;">{{ item.vendorItemId }}</div>
					</template>

					<template v-slot:판매가="{ item }">
						<div>{{ formatNumber(item.salePrice) }}원</div>
					</template>

					<template v-slot:매입가="{ item }">
						<div>{{ formatNumber(item.costPrice) }}원</div>
					</template>

					<template v-slot:월판매량="{ item }">
						<div>{{ formatNumber(item.monthlySales) }}개</div>
					</template>

					<template v-slot:월매출="{ item }">
						<div>{{ formatNumber(item.monthlyRevenue) }}원</div>
					</template>

					<template v-slot:월마진="{ item }">
						<div :class="item.monthlyProfit >= 0 ? 'text-success' : 'text-danger'">
							{{ formatNumber(item.monthlyProfit) }}원
						</div>
					</template>

					<template v-slot:마진율="{ item }">
						<div :class="item.marginRate >= 0 ? 'text-success' : 'text-danger'">
							{{ item.marginRate }}%
						</div>
					</template>

					<template v-slot:상태="{ item }">
						<b-badge :variant="getStatusVariant(item)">{{ getStatusText(item) }}</b-badge>
					</template>
				</CDataTable>
			</div>
		</div>

		<!-- 상품 상세 모달 -->
		<b-modal size="xl" id="scenariodetail" scrollable title="상품 상세 정보" ok-only>
			<div v-if="selectedItem">
				<div class="row mb-3">
					<div class="col-md-4">
						<strong>상품명:</strong> {{ selectedItem.productName }}
					</div>
					<div class="col-md-4">
						<strong>옵션명:</strong> {{ selectedItem.optionName }}
					</div>
					<div class="col-md-4">
						<strong>옵션ID:</strong> {{ selectedItem.vendorItemId }}
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-md-3">
						<strong>판매가:</strong> {{ formatNumber(selectedItem.salePrice) }}원
					</div>
					<div class="col-md-3">
						<strong>매입가:</strong> {{ formatNumber(selectedItem.costPrice) }}원
					</div>
					<div class="col-md-3">
						<strong>수수료:</strong> {{ formatNumber(selectedItem.commission) }}원
					</div>
					<div class="col-md-3">
						<strong>재고:</strong> {{ formatNumber(selectedItem.stock) }}개
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-md-3">
						<strong>월판매량:</strong> {{ formatNumber(selectedItem.monthlySales) }}개
					</div>
					<div class="col-md-3">
						<strong>월매출:</strong> {{ formatNumber(selectedItem.monthlyRevenue) }}원
					</div>
					<div class="col-md-3">
						<strong>월마진:</strong>
						<span :class="selectedItem.monthlyProfit >= 0 ? 'text-success' : 'text-danger'">
							{{ formatNumber(selectedItem.monthlyProfit) }}원
						</span>
					</div>
					<div class="col-md-3">
						<strong>마진율:</strong>
						<span :class="selectedItem.marginRate >= 0 ? 'text-success' : 'text-danger'">
							{{ selectedItem.marginRate }}%
						</span>
					</div>
				</div>

				<div v-if="selectedItem.salesHistory && selectedItem.salesHistory.length > 0">
					<h5>판매 히스토리</h5>
					<div class="table-responsive">
						<table class="table table-sm table-bordered">
							<thead class="thead-light">
								<tr>
									<th v-for="(sales, index) in selectedItem.salesHistory.slice(0, 12)" :key="index">
										{{ index + 1 }}월
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td v-for="(sales, index) in selectedItem.salesHistory.slice(0, 12)" :key="index">
										{{ formatNumber(sales) }}개
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div v-else>
					<p class="text-muted">판매 히스토리 데이터가 없습니다.</p>
				</div>
			</div>
		</b-modal>

		<!-- 엑셀 업로드 모달 -->
		<b-modal size="md" id="excelupload" scrollable title="엑셀 업로드" ok-only>
			<div class="row">
				<div class="col-md-12">
					<p>[업로드 방법]</p>
					<p>1. 엑셀 템플릿 다운로드<br>
						2. 엑셀 파일에서 장부 데이터 입력<br>
						3. 업데이트된 엑셀 파일 업로드<br>
						* 옵션ID는 필수 입력 항목입니다.<br>
						* 기존 데이터가 있으면 업데이트됩니다.</p>
				</div>
				<div class="col-md-12 mt-4">
					<div class="form-group">
						<label>1. 엑셀 템플릿</label>
						<div>
							<button type="reset" @click="downloadTemplate" class="btn btn-primary mr-2">템플릿 다운로드</button>
						</div>
					</div>
				</div>
				<div class="col-md-12">
					<div class="form-group">
						<label for="Code">2. 엑셀 파일 업로드</label>
						<div class="custom-file">
							<input ref="excelupload" type="file" @change="uploadExcel" class="custom-file-input" id="inputGroupFile02">
							<label class="custom-file-label" for="inputGroupFile02">{{ uploadstatus }}</label>
						</div>
						<div class="col-md-12" v-if="showuploadspinner">
							<div>
								<img style="width:5%;" :src="require('../../../assets/images/small/loading.gif')">
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import axios from 'axios'
import CDataTable from "@/components/common/CDataTable";
import * as XLSX from 'xlsx'

export default {
	name: 'BookkeepingManagement',
	components: {
		CDataTable
	},
	data() {
		return {
			title: '장부관리',
			desc1: '실제 판매 데이터 기반 자동 장부 관리',
			desc2: '상품관리의 마진 정보와 SCM관리의 판매량을 연동하여 실시간 손익 계산',
			desc3: '월별/일별 매출, 원가, 수수료, 순이익 자동 집계',

			showlist: true,
			showspinner: false,
			showspinner1: false,
			showuploadspinner: false,
			loadingtext: '',
			uploadstatus: '파일을 선택하세요',

			bookkeepingList: [],
			filteredList: [],
			tableSelectedItem: [],
			selectedItem: null,

			totalProducts: 0,
			profitableProducts: 0,
			lossProducts: 0,

			headers: [
				{ text: '상품명', value: '상품명', align: 'left', width: 250, isSlot: true },
				{ text: '옵션명', value: '옵션명', align: 'left', width: 150, isSlot: true },
				{ text: '옵션ID', value: '옵션ID', align: 'center', width: 100, isSlot: true },
				{ text: '판매가', value: '판매가', align: 'right', width: 100, isSlot: true },
				{ text: '매입가', value: '매입가', align: 'right', width: 100, isSlot: true },
				{ text: '월판매량', value: '월판매량', align: 'right', width: 100, isSlot: true },
				{ text: '월매출', value: '월매출', align: 'right', width: 120, isSlot: true },
				{ text: '월마진', value: '월마진', align: 'right', width: 120, isSlot: true },
				{ text: '마진율', value: '마진율', align: 'center', width: 100, isSlot: true },
				{ text: '상태', value: '상태', align: 'center', width: 100, isSlot: true }
			]
		}
	},
	async mounted() {
		await this.loadBookkeepingData()
	},
	methods: {
		async loadBookkeepingData() {
			try {
				this.showspinner1 = true
				this.loadingtext = '장부 데이터 로딩 중...'
				
				const response = await axios.post('/api/bookkeeping/load')
				if (response.data.res === 'success') {
					this.bookkeepingList = response.data.bookkeeping || []
					this.updateStatistics()
				}
			} catch (error) {
				console.error('장부 데이터 로딩 실패:', error)
				alert('장부 데이터 로딩에 실패했습니다.')
			} finally {
				this.showspinner1 = false
			}
		},
		
		updateStatistics() {
			this.totalProducts = this.bookkeepingList.length
			this.profitableProducts = this.bookkeepingList.filter(item => this.isProfitable(item)).length
			this.lossProducts = this.bookkeepingList.filter(item => this.isLoss(item)).length
			this.filteredList = [...this.bookkeepingList]
		},

		isProfitable(item) {
			return item.monthlyProfit > 0
		},

		isLoss(item) {
			return item.monthlyProfit < 0
		},

		getStatusVariant(item) {
			if (this.isProfitable(item)) return 'success'
			if (this.isLoss(item)) return 'danger'
			return 'secondary'
		},

		getStatusText(item) {
			if (this.isProfitable(item)) return '수익'
			if (this.isLoss(item)) return '손실'
			return '손익분기'
		},
		
		formatDate(date) {
			if (!date) return '-'
			return new Date(date).toLocaleDateString('ko-KR')
		},
		
		async syncRealData() {
			try {
				this.showspinner1 = true
				this.loadingtext = '실제 데이터 동기화 중...'
				
				const response = await axios.post('/api/bookkeeping/sync-data')
				if (response.data.res === 'success') {
					alert('실제 데이터 동기화가 완료되었습니다.')
					await this.loadBookkeepingData()
				} else {
					alert('데이터 동기화에 실패했습니다.')
				}
			} catch (error) {
				console.error('데이터 동기화 실패:', error)
				alert('데이터 동기화에 실패했습니다.')
			} finally {
				this.showspinner1 = false
			}
		},
		
		async saveBookkeeping() {
			try {
				const response = await axios.post('/api/bookkeeping/save', this.bookkeepingList)
				if (response.data.res === 'success') {
					alert('저장이 완료되었습니다.')
				} else {
					alert('저장에 실패했습니다.')
				}
			} catch (error) {
				console.error('저장 실패:', error)
				alert('저장에 실패했습니다.')
			}
		},
		
		async downloadExcel() {
			try {
				this.showspinner1 = true
				this.loadingtext = '엑셀 다운로드 준비 중...'

				const response = await axios.post('/api/bookkeeping/excel/download')
				if (response.data.res === 'success') {
					this.exportToExcel(response.data.data, '장부관리_' + new Date().toISOString().slice(0, 10))
				} else {
					alert('엑셀 다운로드에 실패했습니다.')
				}
			} catch (error) {
				console.error('엑셀 다운로드 실패:', error)
				alert('엑셀 다운로드에 실패했습니다.')
			} finally {
				this.showspinner1 = false
			}
		},

		downloadTemplate() {
			// 템플릿 데이터 생성
			const templateData = [
				{
					vendorItemId: '12345',
					productName: '샘플 상품명',
					optionName: '샘플 옵션명',
					scenario1_name: '시나리오1',
					scenario1_type: 'fixed',
					scenario1_month1_salesPrice: 16500,
					scenario1_month1_costPrice: 7800,
					scenario1_month1_commission: 1960,
					scenario1_month1_monthlySales: 100,
					scenario1_month1_revenue: 1650000,
					scenario1_month1_margin: 294527,
					scenario1_month1_netMargin: 129527
				}
			]
			this.exportToExcel(templateData, '장부관리_템플릿')
		},

		async uploadExcel(event) {
			const file = event.target.files[0]
			if (!file) return

			try {
				this.showuploadspinner = true
				this.uploadstatus = '업로드 중...'

				const data = await this.readExcelFile(file)
				if (data && data.length > 0) {
					const response = await axios.post('/api/bookkeeping/excel/upload', { excelData: data })
					if (response.data.res === 'success') {
						alert(`업로드 완료: ${response.data.cnt_reg}개 신규 등록, ${response.data.cnt_update}개 업데이트`)
						await this.loadBookkeepingData()
						this.uploadstatus = '파일을 선택하세요'
						this.$refs.excelupload.value = ''
					} else {
						alert('업로드에 실패했습니다: ' + response.data.alert)
					}
				} else {
					alert('엑셀 파일에서 데이터를 읽을 수 없습니다.')
				}
			} catch (error) {
				console.error('엑셀 업로드 실패:', error)
				alert('엑셀 업로드에 실패했습니다.')
			} finally {
				this.showuploadspinner = false
			}
		},

		exportToExcel(data, filename) {
			const ws = XLSX.utils.json_to_sheet(data)
			const wb = XLSX.utils.book_new()
			XLSX.utils.book_append_sheet(wb, ws, '장부관리')
			XLSX.writeFile(wb, filename + '.xlsx')
		},

		async readExcelFile(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader()
				reader.onload = (e) => {
					try {
						const data = new Uint8Array(e.target.result)
						const workbook = XLSX.read(data, { type: 'array' })
						const sheetName = workbook.SheetNames[0]
						const worksheet = workbook.Sheets[sheetName]
						const jsonData = XLSX.utils.sheet_to_json(worksheet)
						resolve(jsonData)
					} catch (error) {
						reject(error)
					}
				}
				reader.onerror = reject
				reader.readAsArrayBuffer(file)
			})
		},
		
		showAllProducts() {
			this.filteredList = [...this.bookkeepingList]
		},

		showProfitableProducts() {
			this.filteredList = this.bookkeepingList.filter(item => this.isProfitable(item))
		},

		showLossProducts() {
			this.filteredList = this.bookkeepingList.filter(item => this.isLoss(item))
		},

		refreshData() {
			this.loadBookkeepingData()
		},

		calculateProfit() {
			// 수익 재계산 - 실제로는 서버에서 다시 계산해서 가져옴
			this.syncRealData()
		},

		openProductDetail(item) {
			this.selectedItem = item
			this.$bvModal.show('scenariodetail')
		},

		formatNumber(value) {
			if (value === null || value === undefined) return '0'
			return Number(value).toLocaleString()
		}
	}
}
</script>

<style scoped>
.container-fluid {
	padding: 20px;
}
</style>
